<div *ngIf="segmentedButtons || languages" class="segmented-btn-container">
  <ng-container *ngIf="type === 'view-switcher'">
    <ng-container *ngFor="let button of segmentedButtons; trackBy: trackByFn">
      <rt-segmented-control-button
        *ngIf="button.isAvailable"
        [type]="type"
        [isActive]="button.isActive"
        [isDisabled]="isDisabled"
        [isAvailable]="button.isAvailable"
        [label]="button.label"
        [counter]="button.counter"
        [iconName]="button.iconName"
        [context]="context"
        [fullwidth]="fullwidth"
        (click)="segmentedButtonClicked.emit(button.value)"
      ></rt-segmented-control-button>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="type === 'multilang-switcher'">
    <rt-segmented-control-button
      *ngFor="let language of languages; trackBy: trackByLangCode"
      [type]="type"
      [language]="language"
      [isActive]="language.code === activeLanguage"
      [isDisabled]="isDisabled"
      [isAvailable]="isAvailable"
      [loadingLanguageCode]="loadingLanguageCode"
      [primaryLanguageLabel]="primaryLanguageLabel"
      [fieldsCount]="fieldsCount"
      [context]="context"
      [fullwidth]="fullwidth"
      (click)="segmentedButtonClicked.emit(language)"
    ></rt-segmented-control-button>
  </ng-container>
</div>
